import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class SeedableRandom {
    public state:number;

    constructor(apiPlugin:APIEventSystem) {
        apiPlugin.on(GameModelEvent.INIT, (data:any) => {this.seedOnData(data)})
        apiPlugin.on(GameModelEvent.GAME, (data:any) => {this.seedOnData(data)})
    }

    seed(seed:number) {
        this.state = seed;
    }

    // assumes that the game data contains a 2d array of strings named reels
    // most games do this so its a pretty valid assumption
    // very easy to change if neeed
    seedOnData(data:{reels:string[][]}) {
        this.seed(this.getSeedFromReels(data.reels));
    }

    getSeedFromReels(reels:string[][]) {
        let hash = 5381;

        reels.reduce((a,b) => a.concat(b), []).forEach((symbol) => {
            for (let i = 0; i < symbol.length; i++)
                hash = (symbol.charCodeAt(i) + (hash << 6) + (hash << 16) - hash) & 0xffffffff;
        })

        return hash;
    }

    nextNumber() {
        let temp = this.state;
        temp ^= temp << 13;
        temp ^= temp >> 17;
        temp ^= temp << 5;
        temp = temp & 0xffffffff;
        this.state = temp;
        return (temp >>> 0) / 0xffffffff;
    }

    nextInt(upperLimit:number) {
        return Math.floor(this.nextNumber() * upperLimit);
    }

}